// extracted by mini-css-extract-plugin
export default {"tag":"TagBadge_tag__AyS8i","profession":"TagBadge_profession__1NiSl","hobby":"TagBadge_hobby__XHHWU","skill":"TagBadge_skill__buZnU"};